import React, { useState } from "react";
import {
    Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { connect } from "react-redux";
import * as actions from "../../store/actions/actionIndex";

function CallerIdModal(props) {
  const [callerId, setCallerId] = useState("");

 const handleCall = (skipCallerId = false) => {
  const idToSend = skipCallerId ? "" : callerId;
  props.onCallerIdSelect(idToSend);
};

  return (
    <Dialog
      open={props.isOpen}
      PaperProps={{
        sx: {
          width: "400px", // small modal
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="h6" fontWeight="bold">
          Select Caller ID
        </Typography>
      </DialogTitle >
      <IconButton
        aria-label="close"
        onClick={props.onClose}
        sx={{
          position: 'absolute',
          insetInlineEnd: 8,
          top: 8,
          color: 'grey.500',
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ m: 0, p: 2, pt:0 }}>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Select which caller ID to use when calling {props.phoneNumber}
        </Typography>

        <Box mt={2}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Caller ID
          </Typography>
          <FormControl fullWidth size="small">
          <Select
  labelId="caller-id-label"
  value={callerId}
  onChange={(e) => setCallerId(e.target.value)}
  displayEmpty
  renderValue={(selected) => selected || <span style={{ color: '#aaa' }}>Select Caller ID</span>}
>
  <MenuItem value="">Select Caller ID</MenuItem>

  {props.campConf.caller_id?.length > 0 ? (
    props.campConf.caller_id.map((provider) => {
      const validIds = provider.callerids?.filter((id) => id !== "0") || [];
      return [
        <MenuItem key={`${provider.provider_name}-label`} disabled style={{ fontWeight: 'bold' }}>
          {provider.provider_name}
        </MenuItem>,
        ...validIds.map((id) => (
          <MenuItem key={`${provider.provider_name}-${id}`} value={id}>
            {id}
          </MenuItem>
        ))
      ];
    }).flat()
  ) : (
    <MenuItem disabled value="">
      No Caller ID Available
    </MenuItem>
  )}
</Select>



          </FormControl>
        </Box>
      </DialogContent>

    <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', px: 3, pb: 2 }}>
  <Button 
    onClick={() => handleCall(true)} 
    variant="outlined"
  >
    Skip and Call
  </Button>
  <Button
    onClick={() => handleCall(false)}
    variant="contained"
    color="primary"
    disabled={!callerId}
    startIcon={<PhoneIcon />}
  >
    Call Now
  </Button>
</DialogActions>

  </Dialog>
  );
}
const mapStateToProps =(state)=>{
    return{
        campConf: state.agentConfig.campConf,
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
       onAgentDial: (agentId, phone, leadId, redial, callerId,phoneType) =>
         dispatch(actions.agentDial(agentId, phone, leadId, redial, callerId,phoneType)),
     };
}

export default connect(mapStateToProps, mapDispatchToProps) (CallerIdModal);